document.addEventListener('turbolinks:load', function () {
    // Pages that render the Assign Project modal, including the permit chat
    // (messaging) page — without the body-class here the button does nothing.
    if ($('.projects.show, .project_folders.show, .projects.recent_logs, .projects.permit_chat').length === 0) {
        return false
    }

    $('.approveProject').on('click', function () {
        $('.addToProjectForm').submit();
    })
});